import type { ComponentType, ReactElement } from 'react';

export function isChildInstanceOf<P>(child: ReactElement, Component: ComponentType<P>) {
  return child.type === Component;
}
